import { render, staticRenderFns } from "./ModalUpdateProductStatus.vue?vue&type=template&id=60e5e740"
import script from "./ModalUpdateProductStatus.vue?vue&type=script&lang=js"
export * from "./ModalUpdateProductStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports